<template>
    <div class="a-item-info item-info">
        <span class="item-info__column item-info__column--left">
            <span>
                <span
                    class="item-info__text"
                    v-if="isZoneNameShort"
                >
                    {{ $t('a-item-info_point') }}
                </span>
                <span class="item-info__text">
                    <span
                        v-if="targetZone"
                        class="item-info__name"
                    >
                        {{isZoneNameShort ? '' : targetZone.name}}
                        <span class="item-info__name--last-letter">
                            {{isZoneNameShort ? targetZone.name : targetZone.location}}
                        </span>
                    </span>
                    <span 
                        v-else
                        class="item-info__name"
                    >
                        {{categoryName}}
                    </span>
                </span>
            </span>
        </span>
        <div class="item-info__bottom">
            <span 
                v-if="item.floor.floor_key === '0'"
                class="item-info__text"
            >
                {{ $t('a-item-info_floor--outside') }}
            </span>
            <span
                v-else
                class="item-info__text"
            >
                {{ t(item.floor, 'name')}}
            </span>
            <svg-icon
                v-if="pointIcon"
                original
                name="icons/marker"
                class="item-info__icon"
            />
        </div>
        <!--<span class="item-info__column item-info__column--right">
            <span class="item-info__text">
                <strong>
                    {{ categoryName }}
                </strong>
            </span>
        </span>-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
    
export default {
    name: 'AItemInfo',
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        lastLetterNameBold: {
            type: Boolean,
            default: false
        },
        pointIcon: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapGetters([
            't',
            'getCategoryById'
        ]),
        categoryName() {
            return this.t(this.getCategoryById(this.item.lists.target_zone), 'name')
        },
        isZoneNameShort() {
            return this.categoryName.length < 2
        },
        targetZone() {
            if(this.t(this.getCategoryById(this.item.lists.target_zone), 'name') && this.lastLetterNameBold) {
                return this.getTargetZoneInfo(this.t(this.getCategoryById(this.item.lists.target_zone), 'name'))
            } else {
                return false
            }
        }
    },
    methods: {
        /**
        * This function gets the string and then return Object with target zone - name and location
        * @param {str} String require
        */
        getTargetZoneInfo(str) {
            const arr = str.match(/(\s)(?!.*\1)[\w]*[\w]/gm)
            return {
                name: str.replace(/(\s)(?!.*\1)[\w]*[\w]/gm, ''),
                location: arr ? arr[0].replace(/\s+/g, '') : ''
            }
        }
    }
}
</script>

<style lang="scss">
@import "a-item-info";
</style>